import { ComponentModalConfig, ModalSize } from 'ngx-fomantic-ui';
import {
  ForceConfirmModalComponent,
  IConfirmModalContext,
} from '../force-confirm-modal/force-confirm-modal.component';

export class ForceConfirmModal extends ComponentModalConfig<
  IConfirmModalContext,
  void,
  void
> {
  constructor(title?: string, message?: string, size?: any) {
    super(ForceConfirmModalComponent, { title, message });
    this.isClosable = false;
    this.transitionDuration = 500;
    this.size = ModalSize[size] || ModalSize.Mini;
  }
}
